export const useMyChatStore = defineStore('chatStore', {
  state: () => ({
    isChatStarted: ref(false),
    isChatModalOpen: false,
    intervalId: null as NodeJS.Timeout | null,
    previousMessageNumber: 0,
    newMessageNumber: 0,
    chatModalStatus: false,
  }),
  actions: {
    initChatForTest() {
      // @ts-expect-error releasySupportChatModule exists
      releasySupportChatModule.InitChat(true);
      setTimeout(function () {
        // @ts-expect-error releasySupportChatModule exists
        releasySupportChatModule.sendMessage('-');
      }, 1000);
      setTimeout(() => this.START_INTERVAL(), 1000);
    },
    ToggleChat() {
      const runtimeConfig = useRuntimeConfig();
      if (runtimeConfig.public.isTestEnvironment && !this.isChatStarted) {
        this.initChatForTest();
        return;
      }

      const cookieChatIsMinimize = useCookie('a2be3m1minimizeWindow');

      if (cookieChatIsMinimize.value == '0') {
        // @ts-expect-error releasySupportChatModule exists
        releasySupportChatModule.minimizeWindow();
      } else if (cookieChatIsMinimize.value == '1') {
        // @ts-expect-error releasySupportChatModule exists
        releasySupportChatModule.openStart();
      } else {
        if (runtimeConfig.public.isTestEnvironment) {
          console.log('*** Invalid cookie value or missing cookie. ***');
        }
      }
    },
    CLEAR_INTERVAL_ID() {
      const runtimeConfig = useRuntimeConfig();
      if (runtimeConfig.public.isTestEnvironment) {
        console.log('Clear chat interval...', this.intervalId);
      }

      document.body.classList.remove('no-scroll-mobile');
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = null;
      this.isChatStarted = false;
      this.isChatModalOpen = false;
    },
    START_INTERVAL() {
      const runtimeConfig = useRuntimeConfig();

      if (this.intervalId !== null) {
        return;
      }

      const id = setInterval(() => {
        if (runtimeConfig.public.isTestEnvironment) {
          console.log('Chat interval', id);
        }
        const cookieChatList = useCookie('a2be3m1indexMessage');
        const cookieChatIsMinimize = useCookie('a2be3m1minimizeWindow');

        if (cookieChatIsMinimize.value == '1') {
          this.chatModalStatus = false;

          const messageNumber = Number(cookieChatList.value || 0);
          this.newMessageNumber = messageNumber;

          document.body.classList.remove('no-scroll-mobile');
        } else {
          if (cookieChatList.value) {
            this.newMessageNumber = 0;
          }

          document.body.classList.add('no-scroll-mobile');

          // set chat modal status
          this.isChatModalOpen = true;
        }
        const cookieChatStarted = useCookie('a2be3m1chatstarted');
        const cookieChatSessionName = useCookie('a2be3m1SessionName');

        const isChatActive =
          (cookieChatStarted.value === 'true' ||
            (cookieChatStarted.value as unknown as boolean) === true) &&
          !!cookieChatSessionName.value;

        if (isChatActive) {
          // set chat status
          this.isChatStarted = true;
          const chatFrame = document.getElementById('chatframe');
          if (chatFrame && chatFrame.innerHTML.trim() === '') {
            // open or init releasy chat
            // @ts-expect-error releasySupportChatModule exists
            // eslint-disable-next-line @typescript-eslint/no-unused-expressions
            releasySupportChatModule.chatstarted
              ? // @ts-expect-error releasySupportChatModule exists
                releasySupportChatModule.openStart()
              : // @ts-expect-error releasySupportChatModule exists
                releasySupportChatModule.InitChat();
          }
        } else {
          // clear interval id
          this.CLEAR_INTERVAL_ID();
        }
      }, 1000);

      // set interval id
      this.intervalId = id;
    },
    STOP_INTERVAL() {
      // clear interval id
      this.START_INTERVAL();
      this.CLEAR_INTERVAL_ID();
    },
  },
});
